import React, {useState, useRef} from 'react';

import {defaultTheme} from '@ibibo/build-theme';
import useOutsideClick from '@ibibo/use-outside-click';
import useChildAgePicker from '@ibibo/use-child-age-picker';

import * as S from './RoomInfoBlock.styles';

import IconSelector from '@ibibo/icon-selector';

const ChildAgePicker = ({ageVal, index, actionHandler}) => {
  const [openDropdown, toggleDropdown] = useState(false);
  const childPickerRef = useRef();
  useOutsideClick(childPickerRef, () => {
    toggleDropdown(false);
  });
  return (
    <>
      <S.ChildAgeTextSpan>Child {index + 1} Age</S.ChildAgeTextSpan>
      <S.ChildAgeDropdownWrapper ref={childPickerRef} onClick={() => toggleDropdown(true)}>
        <S.ChildAgeValueSpan>{ageVal}</S.ChildAgeValueSpan>
        <S.ChildAgeIconWrapperSpan>
          <IconSelector iconKey="arrowdown" props={{fill: defaultTheme.colors.blue.base}} />
        </S.ChildAgeIconWrapperSpan>
      </S.ChildAgeDropdownWrapper>
      {(openDropdown && <S.ChildDropdownWrap>
        {[...Array(12)].map((_, arrIndex) => (
          <li
            key={`age${arrIndex}`}
            onClick={() => {
              actionHandler(index, arrIndex + 1);
            }}
          >
            {arrIndex + 1}
          </li>
        ))}
      </S.ChildDropdownWrap>) || null}
    </>
  );
}

const RoomInfoBlock = ({index, guests, roomName, roomAmenities, updateGuestInfo, removeRoom}) => {

  const getChildAgeArray = () => {
    return guests.childs.map(item => item.age);
  }

  const [adultCount, setAdultCount] = useState(guests.adults);
  const [childCount, setChildCount] = useState(guests.childs.length);
  const [childAgeArrayInState, actionHandler, setChildAgeArrayInState] = useChildAgePicker({
    minLimit: 1,
    maxLimit: 12,
    defaultVal: getChildAgeArray(),
  });

  const updateGuests = (data) => {
    updateGuestInfo(index, data);
  }

  const updateChildArr = (childAgeArr) => {
    const childArr = childAgeArr.map(item => {
      return {age: item.toString()};
    });
    updateGuests({childs: childArr});
  }
  
  const updateChildAgeArr = (i, val) => {
    const childArr = childAgeArrayInState.slice();
    childArr[i] = val;
    updateChildArr(childArr);
  }
  
  return(
    <S.RoomInfoMainWrap>
      <S.RoomInfoInnerWrap>
        
        <S.RoomInnerBlock>
          <S.RoomTypeText>{roomName}</S.RoomTypeText>
          <S.RoomAmenitiesWrap>
            {(roomAmenities.map(item => <S.RoomAmenitieInnerWrap key={item}>
              <S.RoomAmenityText>{item}</S.RoomAmenityText>
            </S.RoomAmenitieInnerWrap>)) || null}
          </S.RoomAmenitiesWrap>
        </S.RoomInnerBlock>

        <S.GuestInfoBlock noPadding={guests.removable}>
          
          {(guests.removable && <S.RemoveBlock onClick={() => removeRoom(index)}><S.RemoveCircle>-</S.RemoveCircle></S.RemoveBlock>) || null}
          <S.GuestCountBlock>
            <S.GuestInfoInnerBlock>
              <S.GuestInfoHeadText>ADULTS - above 12y age</S.GuestInfoHeadText>
              <S.GuestSelectWrap>
                <S.GuestCountText>{adultCount}</S.GuestCountText>
                <S.GuestCountBtn
                  disabled={adultCount >= 9}
                  onClick={() => {
                    const count = (parseInt(adultCount) + 1);
                    setAdultCount(count);
                    updateGuests({adults: count.toString()});
                  }}>+</S.GuestCountBtn>
                <S.GuestCountBtn
                  disabled={adultCount <= 1}
                  onClick={() => {
                    const count = (parseInt(adultCount) - 1);
                    setAdultCount(count);
                    updateGuests({adults: count.toString()});
                  }}>-</S.GuestCountBtn>
              </S.GuestSelectWrap>
            </S.GuestInfoInnerBlock>

            <S.GuestInfoInnerBlock>
              <S.GuestInfoHeadText>CHILDRENS - 12yr and below</S.GuestInfoHeadText>
              <S.GuestSelectWrap>
                <S.GuestCountText>{childCount}</S.GuestCountText>
                <S.GuestCountBtn
                  disabled={childCount >= 9}
                  onClick={() => {
                    const count = (parseInt(childCount) + 1);
                    setChildCount(count);
                    childAgeArrayInState.push("1");
                    setChildAgeArrayInState(childAgeArrayInState);
                    updateChildArr(childAgeArrayInState);
                  }}>+</S.GuestCountBtn>
                <S.GuestCountBtn
                  disabled={childCount <= 0}
                  onClick={() => {
                    const count = (parseInt(childCount) - 1);
                    setChildCount(count);
                    childAgeArrayInState.pop();
                    setChildAgeArrayInState(childAgeArrayInState);
                    updateChildArr(childAgeArrayInState);
                  }}>-</S.GuestCountBtn>
              </S.GuestSelectWrap>
            </S.GuestInfoInnerBlock>
          </S.GuestCountBlock>
          <S.ChildAgeBlock>
            {(childAgeArrayInState.length && childAgeArrayInState.map((age, i) => <S.ChildAgeWrapperDiv key={'childAge' + i + 1}>
              <ChildAgePicker
                index={i}
                ageVal={age}
                actionHandler={(i, val) => {
                  actionHandler(i, val);
                  updateChildAgeArr(i, val);
                }}
              />
            </S.ChildAgeWrapperDiv>)) || null}
          </S.ChildAgeBlock>
        </S.GuestInfoBlock>
      </S.RoomInfoInnerWrap>
    </S.RoomInfoMainWrap>
  );
}

export default RoomInfoBlock;